import { useCallback, useState } from "react";
import type { MerchantBusinessFormData } from "../types/merchantRegister.types";
import { useAuthSession } from "../../shared";
import { useCreateMerchantBusinessProfile } from "./useMerchantRegistrationActions";

/** Creates the required business profile, then clears the registration session. */
export const useCompleteMerchantOnboarding = () => {
  const [isCompleting, setIsCompleting] = useState(false);
  const { execute: createBusinessProfile, isLoading: isCreatingBusinessProfile } =
    useCreateMerchantBusinessProfile();
  const { clearSession } = useAuthSession();

  const execute = useCallback(
    async (data: MerchantBusinessFormData) => {
      if (isCompleting) return undefined;

      setIsCompleting(true);
      try {
        const profile = await createBusinessProfile(data);
        if (!profile) return undefined;

        clearSession();
        return profile;
      } finally {
        setIsCompleting(false);
      }
    },
    [clearSession, createBusinessProfile, isCompleting],
  );

  return {
    execute,
    isLoading: isCompleting || isCreatingBusinessProfile,
  };
};
